import React from 'react';
import { StyledManageContactsRemoveEmail, StyledManageContactsRemoveEmailCTA, StyledManageContactsRemoveEmailCustomCTA, StyledManageContactsRemoveEmailDescription } from './styled';
import { Bin, Breakpoints, CTA, Edit, TextAppearance, TextColor, TextCustom, TextLineHeight, TextSize, TextType, TextWeight, ThemeProvider } from '@vw-marketing/us-components';
import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { ManageContactsMutation } from '../../../../shared/typings/main';
import { onVWBasicButtonClickWithProcessEvent } from '../../../../shared/tagging/tagging-helpers';

interface ManageContactsRemoveEmailViewProps {
  trackingManager: any;
  onRemove: (mutation: ManageContactsMutation) => Promise<void>;
  onSuccess: () => void;
  onError: () => void;
  handleAddEditEmail: (flow: "add" | "edit", initialEmail?: string) => void;
  translationHandler: (key: string) => string;
  emailToRemove: string;
}

export const ManageContactsRemoveEmailView: React.FC<ManageContactsRemoveEmailViewProps> = ({
  trackingManager,
  onRemove,
  onSuccess,
  onError,
  handleAddEditEmail,
  translationHandler,
  emailToRemove
}) => {
  const removeEmail = async () => {
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: `Personal Information and Security - Manage Contacts - Remove Email Address`,
        StepNumber: '4.5',
      }, {
        name: 'Remove email address',
      });

      await onRemove({ isEdit: false, isRemove: true, initialValue: emailToRemove, value: emailToRemove });
      onSuccess();
    } catch (error) {
      console.error('There was an error removing your email', error);
      onError();
    }
  };

  return (
    <ThemeProvider theme="main">
      <StyledManageContactsRemoveEmail>
        <StyledManageContactsRemoveEmailDescription>
          <TextCustom
            appearance={TextAppearance.copy200}
            style={{
              [Breakpoints.default]: {
                color: TextColor.primary,
                fontSize: TextSize.TextSize16,
                fontType: TextType.Copy,
                lineHeight: TextLineHeight.TextLineHeight24,
              }
            }}
          >
            <TextCustom
              appearance={TextAppearance.copy200}
              style={{
                [Breakpoints.default]: {
                  color: TextColor.primary,
                  fontWeight: TextWeight.bold,
                  fontSize: TextSize.TextSize16,
                  fontType: TextType.Copy,
                  lineHeight: TextLineHeight.TextLineHeight24,
                }
              }}
            >
              "{applyTextTransformations(emailToRemove, [emailToRemove])}"
            </TextCustom>
            {translationHandler("accountSettings.manage.contacts.interaction.layer.remove.description")}
          </TextCustom>
        </StyledManageContactsRemoveEmailDescription>
        <StyledManageContactsRemoveEmailCTA>
          <StyledManageContactsRemoveEmailCustomCTA
            tag="button"
            icon={<Bin variant="small" />}
            size="large"
            stretchContent={true}
            onClick={async () => await removeEmail()}
          >
            {translationHandler("accountSettings.manage.contacts.interaction.layer.email.alerts.remove.email.cta.remove")}
          </StyledManageContactsRemoveEmailCustomCTA>
          <CTA
            tag="button"
            emphasis='secondary'
            icon={<Edit variant="small" />}
            size="large"
            stretchContent={true}
            onClick={() => handleAddEditEmail('edit', emailToRemove)}
          >
            {translationHandler("accountSettings.manage.contacts.interaction.layer.email.alerts.remove.email.cta.edit")}
          </CTA>
        </StyledManageContactsRemoveEmailCTA>
      </StyledManageContactsRemoveEmail>
    </ThemeProvider>
  )
};
